export const isElementInViewport = (
  element: HTMLElement,
  root: Element,
): boolean => {
  const rect = element.getBoundingClientRect();
  const rootRect = root.getBoundingClientRect();
  return (
    rect.top >= rootRect.top &&
    rect.left >= rootRect.left &&
    rect.bottom <= rootRect.bottom &&
    rect.right <= rootRect.right
  );
};
